import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import seoData from "./seoData";

const SITE_URL = "https://www.ypersystem.com";
const SITE_NAME = "YperSystem Solutions";

function SEO() {
  const location = useLocation();

  const currentPath = location.pathname;

  const seo = seoData[currentPath] || {
    title: `YperSystem Solutions | Technology & Software Solutions`,
    description:
      "YperSystem Solutions provides custom software, AI, ERP, web, cloud, mobile and digital technology solutions for modern businesses."
  };

  const canonicalUrl = `${SITE_URL}${currentPath}`;

  return (
    <Helmet>

      {/* Basic SEO */}
      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <meta
        name="robots"
        content="index, follow"
      />

      <link
        rel="canonical"
        href={canonicalUrl}
      />

      {/* Open Graph */}
      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:title"
        content={seo.title}
      />

      <meta
        property="og:description"
        content={seo.description}
      />

      <meta
        property="og:url"
        content={canonicalUrl}
      />

      <meta
        property="og:site_name"
        content={SITE_NAME}
      />

      <meta
        property="og:image"
        content={`${SITE_URL}/yperlogo.png`}
      />

      {/* Twitter / X */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={seo.title}
      />

      <meta
        name="twitter:description"
        content={seo.description}
      />

      <meta
        name="twitter:image"
        content={`${SITE_URL}/yperlogo.png`}
      />

    </Helmet>
  );
}

export default SEO;